var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4-4h30v30H-4z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#80959D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5.5h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M8.583 2.5h12.834"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#80959D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 8.5h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M8.583 10.5h12.834"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#80959D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 17.5h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M8.583 19.5h12.834"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableInactive);
export default __webpack_public_path__ + "static/media/table-inactive.5842b60a50a712e98c7da9147a2bef38.svg";
export { ForwardRef as ReactComponent };